import { render } from "./addSection.vue?vue&type=template&id=502ec37c&scoped=true"
import script from "./addSection.vue?vue&type=script&lang=js"
export * from "./addSection.vue?vue&type=script&lang=js"

import "./addSection.vue?vue&type=style&index=0&id=502ec37c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502ec37c"]])

export default __exports__